<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="班组类型">
              <a-select placeholder="请选择班组类型" v-model="queryParam.configType">
                  <a-select-option  v-for="item in dateTypeOptions" :value="item.itemValue"  :key="item.itemValue" >{{item.itemText}}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item label="任务状态">
              <a-select placeholder="请选择任务状态" v-model="queryParam.taskState" >
                  <a-select-option  v-for="item in taskStateOptions" :value="item.itemValue"  :key="item.itemValue" >{{item.itemText}}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col> <a-col :xl="4" :lg="7" :md="8" :sm="24">
              <a-form-item label="基地">
              <a-select placeholder="请选择基地" v-model="queryParam.baseId"   @select="baseSelectSelect"  >
                  <a-select-option  v-for="item in baseOptions" :value="item.id"  :key="item.id" >{{item.text}}</a-select-option>
              </a-select>
              </a-form-item>
          </a-col> 
          <a-col :xl="4" :lg="7" :md="8" :sm="24">
              <a-form-item label="部门">
              <a-select placeholder="请选择部门" v-model="queryParam.departId"  @select="departSelectSelect"  >
                  <a-select-option  v-for="item in departOptions" :value="item.id"  :key="item.id" >{{item.text}}</a-select-option>
              </a-select>
              </a-form-item>
          </a-col>
          <a-col :xl="4" :lg="7" :md="8" :sm="24">
              <a-form-item label="车间">
              <a-select placeholder="请选择车间" v-model="queryParam.workshopId">
                  <a-select-option  v-for="item in workshopOptions" :value="item.id"  :key="item.id" >{{item.text}}</a-select-option>
              </a-select>
              </a-form-item>
          </a-col>
          <a-col :xl="5" :lg="7" :md="8" :sm="24">
            <a-form-item label="班组长姓名">
                <a-input placeholder="请输入班组长姓名" v-model="queryParam.workerName"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="10" :lg="11" :md="12" :sm="24"  style="max-width: 550px;"  >
              <a-form-item label="创建时间">
                <j-date :show-time="true" date-format="YYYY-MM-DD" placeholder="请选择开始时间" class="query-group-cust" v-model="queryParam.startDate"></j-date>
                <span class="query-group-split-cust"></span>
                <j-date :show-time="true" date-format="YYYY-MM-DD" placeholder="请选择结束时间" class="query-group-cust" v-model="queryParam.endDate"></j-date>
              </a-form-item>
            </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->
    
    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <!-- <a-button type="primary" icon="download" @click="handleExportXls('巡查汇总表')">导出</a-button> -->
      <!-- <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload> -->
      <!-- <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>删除</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>
      </a-dropdown> -->
    </div>

    <!-- table区域-begin -->
    <div>
      <!-- <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div> -->

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"        
        @change="handleTableChange">
        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无此图片</span>
          <img v-else :src="getImgView(text)" height="25px" alt="图片不存在" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无此文件</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="uploadFile(text)">
            下载
          </a-button>
        </template>
        <span slot="action" slot-scope="text, record">
          <a @click="openSelectUser(record)">查看详情</a>
        </span>
      </a-table>
    </div>
    <table-monitor-detail ref="TableMonitorDetail" :recordChoose="recordChoose"></table-monitor-detail>
  </a-card>
</template>

<script>

  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import {filterMultiDictText} from '@/components/dict/JDictSelectUtil'
  import { postAction, getAction } from '@/api/manage'
  import TableMonitorDetail from './modules/TableMonitorDetail'
  import JDate from '@/components/jeecg/JDate.vue'


  export default {
    name: "TableMonitorSummary",
    mixins:[JeecgListMixin],
    components: {
         JDate,
         TableMonitorDetail
    },
    data () {
      return {
        dateTypeOptions:[],
        taskStateOptions:[],
        workshopOptions:[],
        baseOptions:[],
        departOptions:[],
        // description: '金牌石信息管理页面',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            key:"baseName",
            title:'基地名称',
            align:"center",
            dataIndex: 'baseName'
          },
          {
            key:"departName",
            title:'部门名称',
            align:"center",
            dataIndex: 'departName'
          },
          {
            key:"workshopName",
            title:'车间名称',
            align:"center",
            dataIndex: 'workshopName'
          },
          {
            key:"workerName",
            title:'班长名称',
            align:"center",
            dataIndex: 'workerName'
          },
          {
            key:"taskType_dictText",
            title:'任务类型',
            align:"center",
            dataIndex: 'taskType_dictText'
          },
          {
            key:"taskName",
            title:'任务名称',
            align:"center",
            dataIndex: 'taskName'
          },
          {
            key:"taskState_dictText",
            title:'任务状态',
            align:"center",
            dataIndex: 'taskState_dictText'
          },
          {
            key:"createTime",
            title:'任务创建时间',
            align:"center",
            dataIndex: 'createTime'
          },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            scopedSlots: { customRender: 'action' }
          },
        ],
        url: {
          list: "/standardTeam/task/list",
          modalDetail: "/standardTeam/task/queryById",
          exportXlsUrl:"/busInspectionReport/countQuestionImproveRateExportXls"
        },
        dictOptions:{},
        recordChoose:[],
      }
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      }
    },
    created(){
      getAction("/standardTeam/task/getBaseDepartWorkshop", {}).then((res)=>{
          if(res.code==200){
              this.baseOptions=res.result
          }
      })
      getAction("/sys/dictItem/list", {dictId: '1504013669213159426'}).then((res)=>{
          if(res.code==0){
            this.dateTypeOptions = res.result.records
          }
      })
      getAction("/sys/dictItem/list", {dictId: '1504357233130512385'}).then((res)=>{
          if(res.code==0){
            this.taskStateOptions = res.result.records
          }
      })
    },
    methods: {
      baseSelectSelect(value,options){
        this.departOptions=[];
        this.workshopOptions=[];
          this.$set(this.queryParam,"depart","")
          this.$set(this.queryParam,"workshop","")
          this.baseOptions.some((item)=>{
              if(item.id==value){
                  this.departOptions=item.children
                  return true
              }
          })
        this.queryParam.departId = undefined
        if(this.queryParam.workshopId){
          this.queryParam.workshopId = undefined
        }
        console.log( 'departOptions',this.departOptions)
      },
      departSelectSelect(value,options){
          this.workshopOptions=[];
          this.$set(this.queryParam,"workshop","")
          this.departOptions.some((item)=>{
              if(item.id==value){
                  this.workshopOptions=item.children
                  return true
              }
          })
          if(this.queryParam.workshopId){
            this.queryParam.workshopId = undefined
          }
          console.log('workshopOptions', this.workshopOptions)
      },
      initDictConfig(){
      },
      loadData (arg) {
        if (!this.url.list) {
            this.$message.error("请设置url.list属性!")
            return 
        }
        //加载数据 若传入参数1则加载第一页的内容
        if (arg === 1) {
            this.ipagination.current = 1;
        }
        var params = this.getQueryParams();//查询条件
        params.source='PC'
        this.loading = true;
        postAction(this.url.list, params).then((res) => {
            if (res.success) {
                this.dataSource = res.result.records;
                this.ipagination.total = res.result.total;
                this.pageRefresh ++
                console.log('dataSource', res.result.records)
            }
            if (res.code === 510) {
                this.$message.warning(res.message)
            }
            this.loading = false;
        })
      },
      searchReset(){
        this.queryParam = {};
        this.loadData();
      },
      openSelectUser(record){
        console.log(record);
        if (record.taskState_dictText !== '已完成') {
          this.$message.warning("该任务为待执行状态，暂无数据!")
          return 
        }
        getAction(this.url.modalDetail, {id: record.id}).then((res) => {
            if (res.success) {
              this.recordChoose = []
              this.recordChoose.push(res.result);
              this.$refs.TableMonitorDetail.add(this.recordChoose);
              console.log('recordChoose',this.recordChoose);
            }
            if (res.code === 510) {
                this.$message.warning(res.message)
            }
            this.loading = false;
        })
      },
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>